module.exports = __webpack_public_path__ + "img/banner3.deaaa0b6.png";